//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PreviewProductList from '../index.vue';
export default {
  name: 'PreviewProductListFrom',
  components: {
    PreviewProductList: PreviewProductList
  },
  data: function data() {
    return {
      visible: false,
      multiple: false,
      limit: 100,
      callback: function callback() {},
      valueKey: 'id',
      checked: [],
      isDefault: true
    };
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getStoreItem: function getStoreItem(item) {
      this.callback(item);
      this.visible = false;
    }
  }
};